import unescapedText from 'I18n/utils/unescapedText';
import { useAppIntegrationTags } from 'marketplace-ui-apps-core/common/hooks/useAppIntegrationTags';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { useMemo, useState } from 'react';
import { useAppContext } from '../../../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
function IntegrationsFilter({
  maxHeight,
  onChange,
  trackInteraction,
  value
}) {
  const appContext = useAppContext();
  const {
    data
  } = useAppIntegrationTags(appContext === 'admin-preview' ? 'public' : appContext);
  const [searchTracked, setSearchTracked] = useState(false);
  const options = useMemo(() => data === null || data === void 0 ? void 0 : data.appIntegrationTags.tags.map(text => ({
    text,
    value: text
  })), [data]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.integrations.titleText'),
    maxHeight: maxHeight,
    multi: true,
    name: "integrations",
    onChange: onChange,
    onSearchBlur: () => setSearchTracked(false),
    onSearchChange: event => {
      const search = event.target.value;
      if (searchTracked || !search.trim()) return;
      trackInteraction('search app integrations');
      setSearchTracked(true);
    },
    options: options || [],
    scrollable: true,
    searchable: true,
    searchPlaceholder: unescapedText('appMarketplace.storefront.filters.integrations.searchInputPlaceholder'),
    value: value,
    virtualized: true
  });
}
export default IntegrationsFilter;